import Colorable from "./Colorable.mjs";

export default {

    mixins: [Colorable],

    computed: {
        textColorString() {
            if (this.colorString) {
                return `text-${this.colorString}`;
            }

            return null;
        }
    }
}
